import { htmlToSlate, RichText } from '@amelio/ui-library';
import { useMemo } from 'react';

import { useSelectedAppLanguage } from '@/hooks';
import { decodeAndSanitize } from '@/utils/htmlSanitizer';

interface RecognitionMessageProps {
    /** The message as Engagement stored it, still untrusted when it gets here. */
    html: string;
}

/**
 * The message of a recognition, in the rich text its author wrote. The markup comes from another
 * application's editor, so it is sanitized before it becomes anything, and then read the way the
 * module reads every other stored rich text.
 */
export const RecognitionMessage = ({ html }: RecognitionMessageProps) => {
    const language = useSelectedAppLanguage();
    const message = useMemo(() => htmlToSlate(decodeAndSanitize(html)), [html]);

    return (
        <RichText
            value={message}
            readOnly
            toolbar={false}
            locale={language}
            contentMinHeight={'auto'}
            dataTestId={'employee-portal-recognition-message'}
        />
    );
};
